import { useReducer, useEffect } from "react";
import energyConsumptionReducer from "./reducer";
import { fetchEnergyConsumption } from "./api";
import ACTIONS from "./actions";
import { getEnergyConsumptionDateFormat, transformEnergyConsumptionData } from "../../../../lib/utils/utility";
import { fetchSiteIdBySerial } from "../../../../lib/hooks/api";

const initialState = {
  isLoading: false,
  isError: false,
  data: [],
};

async function getEnergyConsumptionDetails(dispatch, chargerId, timeRange, siteId) {
  const startTime = getEnergyConsumptionDateFormat(new Date(timeRange[0]));
  const endTime = getEnergyConsumptionDateFormat(new Date(timeRange[1]));
  dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_INIT });
  let energyConsumptionData;
  try {
    energyConsumptionData = await fetchEnergyConsumption(siteId, startTime, endTime, chargerId);
  } catch (e) {
    console.log("error->", e);
  }
  if (energyConsumptionData) {
    const data = energyConsumptionData?.e_c;
    const finalResult = transformEnergyConsumptionData(data, startTime, endTime, timeRange[0], timeRange[1]);
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_SUCCESS, payload: finalResult });
  } else {
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_FAILURE });
  }
}

function useEnergyConsumptionReducer({ chargerId, timeRange }) {
  const [state, dispatch] = useReducer(energyConsumptionReducer, initialState);
  const fetchData = async () => {
    const res = await fetchSiteIdBySerial(chargerId);
    const siteId = (Array.isArray(res?.data) && (res.data[0]?.siteId || res.data[0]?.systemId)) || null;
    if (siteId && chargerId && timeRange) {
      getEnergyConsumptionDetails(dispatch, chargerId, timeRange, siteId);
    }
  };

  useEffect(() => {
    fetchData();
  }, [timeRange, chargerId]);

  return {
    state,
    dispatch,
  };
}

export default useEnergyConsumptionReducer;
